// chat-input-ce.component.ts
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-chat-input',
  imports: [
    MatButtonModule,
    MatIconModule
  ],
  standalone: true,
  templateUrl: './chat-input.component.html',
  styleUrls: ['./chat-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatInputComponent {
  @Input() placeholder = 'Message…';
  @Input() disabled = false;

  @Input() spellcheck: 'true' | 'false' = 'true';
  @Input() autocapitalize: 'off' | 'on' | 'sentences' | 'words' | 'characters' =
    'sentences';
  @Input() autocomplete: string = 'off';
  @Input() inputmode:
    | 'text'
    | 'search'
    | 'none'
    | 'tel'
    | 'url'
    | 'email'
    | 'numeric'
    | 'decimal' = 'text';

  @Output() messageSend = new EventEmitter<string>();

  @ViewChild('input') ce?: ElementRef<HTMLDivElement>;

  private textCache = '';

  onInput(): void {
    this.textCache = this.getPlainText();
    // this.clampHeight();
  }

  canSend(): boolean {
    return this.textCache.trim().length > 0;
  }

  send(): void {
    if (this.disabled) return;

    const text = this.getPlainText().trim();
    if (!text) return;

    this.messageSend.emit(text);

    const el = this.ce?.nativeElement;
    if (el) el.innerText = '';
    this.textCache = '';
    queueMicrotask(() => el?.focus());
  }

  onKeydown(e: KeyboardEvent): void {
    // Enter sends, Shift+Enter adds newline
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      this.send();
    }
  }

  onPaste(e: ClipboardEvent): void {
    // paste as plain text (strip HTML)
    e.preventDefault();
    const text = e.clipboardData?.getData('text/plain') ?? '';
    document.execCommand('insertText', false, text);
  }

  private getPlainText(): string {
    const el = this.ce?.nativeElement;
    if (!el) return '';
    return el.innerText.replace(/\u00A0/g, ' ');
  }
}
